import {FC, useEffect, useRef, useState} from 'react';
import {ChevronDown, ChevronUp} from '@carbon/icons-react';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {useOnClickOutside} from '@hooks/useOnClickOutside';
import {ISystem} from '@types';
import {
  PageTitleDropdownBtnWrapper,
  PageTitleDropdownRow,
  PageTitleDropdownWrapper,
} from '@atoms/PageTitleDropdownBtn.styles';
import {ERoutes} from '@constants/routes';
import {useNavigate} from 'react-router';

export interface PageTitleDropdownBtnProps {
  systems?: ISystem[];
}

const PageTitleDropdownBtn: FC<PageTitleDropdownBtnProps> = ({systems = []}) => {
  const [menuShow, setMenuShow] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Закрытие меню при клике вне меню
  useOnClickOutside(menuRef, () => setMenuShow(false));

  // Закрытие меню при нажатии Esc
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setMenuShow(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <PageTitleDropdownBtnWrapper onClick={() => setMenuShow(!menuShow)}>
      {!menuShow && <ChevronDown size={16} />}
      {menuShow && <ChevronUp size={16} />}
      {menuShow && (
        <PageTitleDropdownWrapper ref={menuRef} onMouseLeave={() => setMenuShow(false)}>
          {systems.map(system => {
            return (
              <PageTitleDropdownRow
                key={`dropdown-system-${system.id}`}
                onClick={() =>
                  navigate(ERoutes.SYSTEM_DETAILS.replace(':id', String(system.id)))
                }>
                <Text text={system.name} type="bodyM" color={theme.colors.accent00} />
              </PageTitleDropdownRow>
            );
          })}
        </PageTitleDropdownWrapper>
      )}
    </PageTitleDropdownBtnWrapper>
  );
};

export default PageTitleDropdownBtn;
